import { isSameDay, isToday } from "date-fns"
import React, { useState } from "react"
import Calendar from "react-calendar"
//import "react-calendar/dist/Calendar.css";
import "./Calendar.scss"

export default function MyActivitiesCalendar({ pastDates, upcomingDates }) {
  const [value, onChange] = useState(new Date())

  function tileClassName({ date, view }) {
    // Add class to tiles in month view only
    if (view === "month") {
      // Check if a date React-Calendar wants to check is on the list of dates to add class to
      if (pastDates.find((dDate) => isSameDay(dDate, date))) {
        if (isToday(date)) {
          return "todayWorkout"
        }
        return "pastWorkout"
      } else if (upcomingDates.find((dDate) => isSameDay(dDate, date))) {
        return "upcomingWorkout"
      }
    }
  }

  return (
    <Calendar
      onChange={onChange}
      value={value}
      prev2Label={null}
      next2Label={null}
      calendarType={"gregory"}
      minDetail={"month"}
      className={"box-layer2"}
      tileClassName={tileClassName}
      showNeighboringMonth={false}
    />
  )
}
